const { DOMUtils } = window.Liftoff;

const isVariationSelector = (cstr) => {
  if (cstr.length !== 1) {
    return false;
  }

  const code = cstr.charCodeAt(0);

  return 0xfe00 <= code && code <= 0xfe0f;
};

// Expects an array generated by [...str].
// Merges variation selectors into the previous character so that they do not occupy their own slot in the
// array.
// REFERENCE: See
// - https://blog.jonnew.com/posts/poo-dot-length-equals-two
// - https://codepoints.net/U+fe0f
// - https://codepoints.net/variation_selectors
const mergeVariationSelectors = (unicodechars) =>
  unicodechars.reduce((acc, cstr) => {
    if (acc.length > 0 && isVariationSelector(cstr)) {
      acc[acc.length - 1] += cstr;
    } else {
      acc.push(cstr);
    }
    return acc;
  }, []);

export const unicodeLen = (str) => mergeVariationSelectors([...str]).length;

// Returns a string consisting of the leftmost 'n' Unicode characters of 'str'.
export const unicodeSlice = (str, n) =>
  mergeVariationSelectors([...str])
    .slice(0, n)
    .join("");

export const domCountCharacters = (tree) => {
  if (tree == null) {
    return 0;
  }

  if (tree.nodeType === Node.TEXT_NODE) {
    return unicodeLen(tree.nodeValue);
  }

  let numChars = 0;

  if (tree.hasChildNodes()) {
    [...tree.childNodes].forEach((child) => {
      numChars += domCountCharacters(child);
    });
  }

  return numChars;
};

// Return a copy of the tree, such that only the leftmost n characters in the text elements are preserved.
//
// The return value includes the new tree and the number of characters in it.
//
export const domSlice = (tree, n) => {
  if (tree == null) {
    return { tree: null, charcount: 0 };
  }

  if (tree.nodeType === Node.TEXT_NODE) {
    const text = tree.nodeValue;
    const textLen = unicodeLen(text);
    const numCharsToPreserve = Math.min(n, textLen);
    const newText = unicodeSlice(text, numCharsToPreserve);

    return {
      tree: document.createTextNode(newText),
      charCount: numCharsToPreserve,
    };
  }

  const ret = {
    tree: tree.cloneNode(false),
    charCount: 0,
  };

  if (tree.hasChildNodes()) {
    const children = [...tree.childNodes];
    children.forEach((child) => {
      const slicedChild = domSlice(child, n - ret.charCount);

      ret.charCount += slicedChild.charCount;

      if (slicedChild.charCount > 0 || child.textContent.length === 0) {
        ret.tree.appendChild(slicedChild.tree);
      }
    });
  }

  return ret;
};

// Removes any children of dstnode and moves the children of srcnode into dstnode.
export const moveChildrenFromNode = (dstnode, srcnode) => {
  dstnode = DOMUtils.empty(dstnode);

  while (srcnode.firstChild) {
    const child = srcnode.removeChild(srcnode.firstChild);

    dstnode.appendChild(child);
  }

  return dstnode;
};

export const getTextDom = (caption) => {
  const div = document.createElement("div");
  div.innerHTML = caption;

  return div;
};



// WEBPACK FOOTER //
// ./src/js/lib/text_anim.js